define('SageDotCom/Components/Content/AutoFileDownloader',["jquery"],
    function ($) {

        function AutoFileDownloader(scope) {
            var referrer =  document.referrer;
            var approvedOrigin = $(".auto-file-downloader").attr('referrer');
            var redirectUrl = $(".auto-file-downloader").attr('redirect');
            
            if (referrer.indexOf(approvedOrigin) > -1) {
                $(".auto-file-downloader")[0].click();
            } else {
                window.location.replace(redirectUrl);
            }
        }

        AutoFileDownloader.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new AutoFileDownloader(args.scope);
        };

        return AutoFileDownloader;
    });
